import { catchError, filter, switchMap } from 'rxjs/operators';
import { concat, EMPTY, from, of } from 'rxjs';
import axios from 'axios-observable';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { ContractModel } from '@/models';
import { FetchAllContractsPayload } from '@/store/slices/staff/contracts.slice';
import { objectToUrlSearchParams } from '@/utils/url-search-params-utils';

export const fetchAllContractsEpic: PayloadEpic<FetchAllContractsPayload, ContractModel[]> = (action$) => {
    return action$.pipe(
        filter(asyncActions.contracts.fetchAll.match),
        switchMap(({ payload }) => concat(
            of(actions.contracts.setIsLoading(true)),
            fetchContracts(payload).pipe(
                switchMap(({ data }) => from([
                    actions.contracts.setAll(data.results),
                    actions.contracts.setTotalCount(data.count),
                ])),
                catchError((error) => {
                    console.error('fetchAllContractsEpic', error);

                    return EMPTY;
                }),
            ),
            of(actions.contracts.setIsLoading(false)),
        )),
    );
};

const fetchContracts = (payload: FetchAllContractsPayload) => {
    const searchParams = objectToUrlSearchParams(payload);

    return axios.get<ListResponse<ContractModel>>(`${apiEndpoints.contracts()}?${searchParams}`);
};
